export enum ECarriersList {
	BASIC_CARRIER = 'BASIC',
	FASCHIM_CARRIER = 'FASCHIM',
	CHUBB_CARRIER = 'CHUBB',
	DECARE_CARRIER = 'DECARE',
}

export interface ICarrierIntegrationInfo {
	carrierClaimId: string | null;
	customFaschimExtraInfo: string | null;
	memberFiscalCode: string | null;
}
export interface ICarrier {
	carrierCode: string;
	name: string;
	knownAsName: string;
	effectiveDate: string;
	terminationDate: string;
	customLayout: TCarrierFlow;
}

export interface IState {
	carriers: ICarrier[];
}

export type TCarrierFlow = ECarriersList | null;
